// import React, { useState, useEffect } from "react";
// import CloseIcon from "@mui/icons-material/Close";
// const MobilePlans = ({ onClose, onSelectPlan, plansData }) => {
//   const [selectedCategory, setSelectedCategory] = useState("TOPUP");
//   const [plans, setPlans] = useState({});
//   useEffect(() => {
//     if (!plansData) return;
//     const formattedPlans = {};
//     for (const category in plansData) {
//       const data = plansData[category];
//       if (!data) continue;
//       formattedPlans[category] = data?.map((item) => ({
//         validity: item.validity,
//         amount: parseInt(item.rs), // convert rs to number
//         description: [item.desc],
//       }));
//     }
//     setPlans(formattedPlans);
//   }, [plansData]);
//   const categories = Object.keys(plans);
//   const selectedPlans = plans[selectedCategory] || [];
//   const noPlans = selectedPlans.length === 0;
//   const handleRechargeClick = (plan) => {
//     onSelectPlan(plan.amount, plan.description);
//   };
//   return (
//     <div className="p-4 sm:p-6 ds-card font-[Poppins] mb-2 w-full">
//       <div className="flex justify-between items-center">
//         <h2 className="text-base sm:text-xl font-semibold text-gray-800">
//           Browse Plans
//         </h2>
//         <button onClick={onClose} className="text-red-500 font-semibold">
//           <CloseIcon fontSize="small" />
//         </button>
//       </div>
//       <div className="flex flex-nowrap overflow-x-auto gap-2 mt-4 border-b pb-2">
//         {categories.map((category) => (
//           <button
//             key={category}
//             onClick={() => setSelectedCategory(category)}
//             className={`px-2 py-1 text-[10px] sm:text-xs whitespace-nowrap rounded transition ${
//               selectedCategory === category
//                 ? "bg-[#02026E] text-white"
//                 : "bg-gray-100 hover:bg-gray-200"
//             }`}
//           >
//             {category}
//           </button>
//         ))}
//       </div>
//       <h3 className="mt-4 text-xs sm:text-sm font-semibold text-gray-600">
//         {selectedCategory}
//       </h3>
//       {noPlans ? (
//         <p className="text-center text-gray-500 mt-4">
//           No plans found in this category
//         </p>
//       ) : (
//         <div className="space-y-3 mt-4">
//           {selectedPlans.map((plan, index) => (
//             <div
//               key={index}
//               className="border rounded-lg p-3 shadow hover:shadow-md transition flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3"
//             >
//               <div className="text-center sm:w-20">
//                 <p className="text-[10px] sm:text-xs text-gray-500">Validity</p>
//                 <p className="font-bold text-sm sm:text-base">{plan.validity}</p>
//               </div>
//               <div className="flex-1">
//                 <p className="font-semibold text-sm sm:text-base">
//                   Amount : <span className="text-red-500"> ₹{plan.amount}</span>
//                 </p>
//                 <p className="text-[11px] sm:text-sm font-semibold text-gray-600 mt-1">
//                   Description :
//                 </p>
//                 <ul className="text-gray-600 text-[11px] sm:text-sm list-disc ml-4 sm:ml-5">
//                   {plan.description.map((line, i) => (
//                     <li key={i}>{line}</li>
//                   ))}
//                 </ul>
//               </div>
//               <button
//                 onClick={() => handleRechargeClick(plan)}
//                 className="w-full sm:w-auto px-3 py-2 bg-[#02026E26] hover:bg-[#02026E43] text-[#02026E] font-medium rounded-lg text-xs sm:text-sm"
//               >
//                 Select Plan
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };
// export default MobilePlans;




import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const MobilePlans = ({ onClose, onSelectPlan, plansData }) => {
  const [selectedCategory, setSelectedCategory] = useState("TOPUP");
  const [plans, setPlans] = useState({});
  const [error, setError] = useState(null);

  // ✅ Format & Validate Plans Data Safely
  useEffect(() => {
    try {
      if (!plansData || typeof plansData !== "object") {
        setError("Plans data not available");
        setPlans({});
        return;
      }

      const formattedPlans = {};

      for (const category in plansData) {
        const data = plansData[category];

        if (!Array.isArray(data)) continue;

        formattedPlans[category] = data.map((item) => ({
          validity: item?.validity || "N/A",
          amount: Number(item?.rs) || 0,
          description: item?.desc ? [item.desc] : ["No description available"],
        }));
      }

      setPlans(formattedPlans);
      setError(null);
    } catch (err) {
      console.error("MobilePlans Error:", err);
      setError("Something went wrong while loading plans");
      setPlans({});
    }
  }, [plansData]);

  const categories = Object.keys(plans);
  const selectedPlans = plans[selectedCategory] || [];
  const noPlans = selectedPlans.length === 0;

  const handleRechargeClick = (plan) => {
    if (!onSelectPlan) return;
    onSelectPlan(plan.amount, plan.description);
  };

  return (
    <div className="ds-card p-4 sm:p-5 mb-2 w-full">
      <div className="flex justify-between items-center">
        <h2 className="text-base sm:text-lg font-semibold text-[var(--text-dark)]">
          Browse Plans
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="text-[var(--error-color)] font-semibold"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      {error && (
        <div className="mt-3 ds-alert ds-alert-error text-xs sm:text-sm">
          {error}
        </div>
      )}

      <div className="flex flex-nowrap overflow-x-auto ds-scroll gap-2 mt-4 border-b border-[var(--border-color)] pb-2">
        {categories.length > 0 ? (
          categories.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => setSelectedCategory(category)}
              className={`px-2 py-1 text-[10px] sm:text-xs whitespace-nowrap rounded-[var(--radius-sm)] transition ${
                selectedCategory === category
                  ? "bg-[var(--primary-color)] text-white"
                  : "bg-primary-soft make-text-primary"
              }`}
            >
              {category}
            </button>
          ))
        ) : (
          <span className="text-[var(--text-muted)] text-xs">No Categories</span>
        )}
      </div>

      <h3 className="mt-4 text-xs sm:text-sm font-semibold text-[var(--text-muted)]">
        {selectedCategory}
      </h3>

      {noPlans ? (
        <p className="text-center text-[var(--text-muted)] mt-4 text-sm">
          No plans found in this category
        </p>
      ) : (
        <div className="space-y-3 mt-4">
          {selectedPlans.map((plan, index) => (
            <div
              key={index}
              className="ds-panel p-3 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3"
            >
              <div className="text-center sm:w-20">
                <p className="text-[10px] sm:text-xs text-[var(--text-muted)]">
                  Validity
                </p>
                <p className="font-bold text-sm sm:text-base text-[var(--text-dark)]">
                  {plan.validity}
                </p>
              </div>

              <div className="flex-1">
                <p className="font-semibold text-sm sm:text-base text-[var(--text-dark)]">
                  Amount :
                  <span className="text-[var(--error-color)]"> ₹{plan.amount}</span>
                </p>
                <p className="text-[11px] sm:text-sm font-semibold text-[var(--text-muted)] mt-1">
                  Description :
                </p>
                <ul className="text-[var(--text-muted)] text-[11px] sm:text-sm list-disc ml-4 sm:ml-5">
                  {plan.description?.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>

              <button
                type="button"
                onClick={() => handleRechargeClick(plan)}
                className="ds-btn ds-btn-ghost w-full sm:w-auto text-xs sm:text-sm"
              >
                Select Plan
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobilePlans;
